import * as React from 'react';
import type { CheckoutPriceOverviewItem, CheckoutPriceOverviewSubItems } from '../../domain/types/priceOverview';
import { styled } from 'styled-components';
import { Typography, tok, space, tokPx } from '@sunwebgroup/ui-components';
import { Price } from '../services/ServiceComponents';

export function BreakDownTable(props: { items: CheckoutPriceOverviewItem[] }) {
  const { items } = props;

  return (
    <BreakDownTableBox>
      {items?.map((item, idx) => (
        <ItemBox key={`break-down-item${idx}`}>
          <ItemContent as={item.total ? Total : ItemContent}>
            <ItemContentLeftItem isDiscount={item.isDiscount} $variant={item.total ? 'body-lg-bold' : 'body-md'}>
              {item.concept || ''}
            </ItemContentLeftItem>
            <BreakDownTablePrice isDiscount={item.isDiscount} $variant={item.total ? 'body-lg-bold' : 'body-md-bold'}>
              {item.value || ''}
            </BreakDownTablePrice>
          </ItemContent>

          {item.subitems?.map((subitem) => {
            return (
              <>
                {SubItem(subitem, item.isDiscount)}
                {subitem.subitems && subitem.subitems.length > 0 && (
                  <div>{subitem.subitems.map((child) => SubItem(child))}</div>
                )}
              </>
            );
          })}
        </ItemBox>
      ))}
    </BreakDownTableBox>
  );
}

function SubItem(subitem: CheckoutPriceOverviewSubItems, isDiscount?: boolean) {
  return (
    <SubItemContent>
      <SubItemText isDiscount={isDiscount}>{subitem.concept}</SubItemText>
      <Price>{subitem.value ? subitem.value : ''}</Price>
    </SubItemContent>
  );
}

const SubItemContent = styled.div`
  display: flex;
  margin-top: ${space('primitives_space_4')};
`;

const BreakDownTableBox = styled.div`
  margin-bottom: ${space('primitives_space_24')};
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 0;
`;

const ItemBox = styled.div`
  padding: ${space('primitives_space_16')} ${space('primitives_space_12')};
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
`;

const Total = styled(ItemContent)`
  margin-top: ${space('primitives_space_24')};
  border-bottom: 0;
  border-top: ${tokPx('semantics_dividers_tickness')} solid ${tok('primitives_color_neutral_850')};
  text-transform: unset;
`;

const BreakDownTablePrice = styled(Price)<{ isDiscount?: boolean }>`
  color: ${({ isDiscount }) => getTextColor(isDiscount ?? false, false)};
`;

const ItemContentLeftItem = styled(Typography)<{ isDiscount?: boolean }>`
  font-style: normal;
  color: ${({ isDiscount }) => getTextColor(isDiscount ?? false, false)};
`;

const SubItemText = styled(Typography)<{ isDiscount?: boolean }>`
  color: ${({ isDiscount }) => getTextColor(isDiscount ?? false, true)};
  font-size: ${tokPx('primitives_font_size_body_xs')};
`;

const getTextColor = (isDiscount: boolean, isSubItem: boolean) => {
  if (isDiscount) {
    return tok('primitives_color_green_350');
  } else if (isSubItem) {
    return tok('primitives_color_neutral_450');
  }
  return tok('primitives_color_neutral_800');
};
